import { useCallback, useContext, useMemo } from 'react'
import { useLocation } from 'react-router-dom'

import { PAGE_ROUTES } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/routingConstants'
import { isEmailCapturePageExperimentV2InControlGroup } from '@lyrahealth-inc/shared-app-logic/src/features/experiments/utils'
import { useFlags } from '@lyrahealth-inc/shared-app-logic/src/features/flags/useFlags'
import { ProductTypeContext } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/productType/productTypeContext'

export const useShowEmailCapturePageExperimentV2 = () => {
  const { emailCapturePageExperimentV2 } = useFlags()
  const { isLyraSelect } = useContext(ProductTypeContext)
  const { pathname } = useLocation()

  const isV2PathForLyraSelect = useCallback(() => {
    return [PAGE_ROUTES.REGISTER, PAGE_ROUTES.REGISTER_VERIFY].some((path) => pathname.startsWith(path))
  }, [pathname])

  const showEmailCapturePageExperimentV2 = useMemo(() => {
    return isLyraSelect
      ? isV2PathForLyraSelect()
      : !!emailCapturePageExperimentV2 && !isEmailCapturePageExperimentV2InControlGroup(emailCapturePageExperimentV2)
  }, [emailCapturePageExperimentV2, isLyraSelect, isV2PathForLyraSelect])

  return { showEmailCapturePageExperimentV2, emailCapturePageExperimentV2 }
}
